import {
  getActiveExecutionSubGroupUrl,
  executionSubGroupUrl,
  getPaginatedExecutionSubGroupUrl,
  getExecutionSubGroupDetailUrl,
} from "./constants";
import base from "../middlewares/interceptors";
import { getConfig } from "../config/runtimeConfig";

export const getActiveExecutionSubGroup = async () => {
  try {
    const response = await base.get(getActiveExecutionSubGroupUrl);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const getPaginatedExecutionSubGroup = async ({
  page,
  pSize,
  searchTerm,
  signal,
  isActive = "true",
}: any) => {
  try {
    const defaultPage = getConfig("REACT_APP_DEFAULT_PAGE", "1");
    const defaultPageSize = getConfig("REACT_APP_DEFAULT_PAGE_SIZE", "25");

    const pageN = page || defaultPage;
    const pageSize = pSize || defaultPageSize;

    const params: { [key: string]: any } = {
      page: pageN,
      size: pageSize,
    };

    // Conditionally add is_active parameter only when it's "true" or "false" (not "all")
    if (isActive && isActive !== "all") {
      params.is_active = isActive;
    }

    // Add search parameter if searchTerm is provided and has minimum 3 characters
    if (searchTerm && searchTerm.trim().length >= 3) {
      params.name = searchTerm.trim();
    }

    const response = await base.get(getPaginatedExecutionSubGroupUrl, {
      params,
      signal,
    });
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getExecutionSubGroupDetail = async ({
  currentExecutionSubGroupId,
}: any) => {
  try {
    const response = await base.get(
      `${getExecutionSubGroupDetailUrl}/${currentExecutionSubGroupId}`
    );
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const addExecutionSubGroup = async ({ payload }: any) => {
  try {
    const response = await base.post(executionSubGroupUrl, payload);
    return response.data;
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const updateExecutionSubGroup = async ({
  currentExecutionSubGroupId,
  payload,
}: any) => {
  try {
    const response = await base.put(
      `${executionSubGroupUrl}/${currentExecutionSubGroupId}`,
      payload
    );
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export const deleteExecutionSubGroup = async (
  currentExecutionSubGroupId: number
) => {
  try {
    const response = await base.delete(
      `${executionSubGroupUrl}/${currentExecutionSubGroupId}`
    );
    return { response: response.data, status: response.status };
  } catch (error) {
    console.error(error);
  }
};

/**
 * Reactivate execution sub group
 * @param executionSubGroupId - The ID of the execution sub group to reactivate
 * @returns Promise with reactivation result
 */
export const reactivateExecutionSubGroup = async (
  executionSubGroupId: string | number
) => {
  try {
    const response = await base.put(
      `${executionSubGroupUrl}/${executionSubGroupId}/reactivate`
    );
    return response.data;
  } catch (error) {
    console.error("Error reactivating execution sub group:", error);
    throw error;
  }
};
